import { CircularProgress, Tooltip } from '@mui/material'
import { IconButton } from '@weberlo/components'

import RefreshIcon from '@mui/icons-material/Refresh'

const RefreshButton = ({ refreshing, onClick, sx }: Props) => {
  return (
    <Tooltip title="Refresh the data">
      <IconButton
        size="small"
        color="inherit"
        onClick={onClick}
        sx={{
          border: '1px solid var(--mui-palette-primary-light)',
          height: 32,
          width: 32,
          borderRadius: 2,
          m: 0,
          '& .MuiSvgIcon-root': {
            fontSize: 18,
          },
          ...sx,
        }}>
        {refreshing ? (
          <CircularProgress
            size={20}
            thickness={5}
            color="inherit"
          />
        ) : (
          <RefreshIcon />
        )}
      </IconButton>
    </Tooltip>
  )
}

interface Props {
  refreshing: boolean
  onClick: () => void
  sx?: any
}

export default RefreshButton
